import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TenantDto } from '@nusign/picflow-backend-types';
import { ButtonDirective } from '../../directives/button.directive';
import { TooltipDirective } from '../../directives/tooltip.directive';
import { SvgComponent } from '../svg/svg.component';

@Component({
  selector: 'app-tenant-logo-and-contacts',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, TooltipDirective, SvgComponent, RouterLink],
  templateUrl: './tenant-logo-and-contacts.component.html',
  styleUrls: ['./tenant-logo-and-contacts.component.scss'],
})
export class TenantLogoAndContactsComponent {
  @Input({ required: true }) tenant: TenantDto;
  @Input() link: string[] | string;
  @Input() small: boolean;
  @Input() darkBg: boolean;

  niceSite(site: string) {
    if (!site) return '';
    if (site.split('//').length === 1) return site;
    return site.split('//')[1];
  }
}
